module.exports = __webpack_public_path__ + "img/shinji.02c0dd72.jpg";